<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      :model="model"
      :required-date-value="dateRange"
      :use-action="false"
      :use-default-action="false"
      entity-name="operationRecords"
      icon="mdi-cards"
    >
      <template #footer="{}">
        <date-picker-input
          v-model="dateRange"
          card-class="pa-3"
          color="grey lighten-3"
        />
      </template>
    </ik-data-table>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import ChangeLog from '@/model/dataLayer/api/storage/ChangeLog'
import DatePickerInput from '@/views/AadenPages/dashboard/components/DatePickerInput.vue'
import { defaultDate } from '@/model/dataLayer/api/common/DateRepository'

export default {
  name: 'ChangeLogPage',
  components: {
    DatePickerInput,
    IkDataTable
  },
  data () {
    return {
      dateRange: [defaultDate, defaultDate],
      model: ChangeLog
    }
  }
}
</script>

<style scoped>

</style>
